import { Drawer, Image } from 'antd'
import { TokenType, useTokenStore } from 'state/useTokenStore'
import { twMerge } from 'tailwind-merge'
import { useTranslation } from 'translations'

const SelectToken = ({ onClose, open }) => {
	const { t } = useTranslation()
	const tokenList = useTokenStore((s) => s.tokenList)
	const setTokenFrom = useTokenStore((s) => s.setTokenFrom)

	const onSelect = (fiat: TokenType) => {
		setTokenFrom(fiat)
		onClose()
	}

	return (
		<Drawer
			title={<p className='text-center font-bold text-xl'>{t("Send from")}</p>}
			placement="bottom"
			className='container !px-0'
			closable={false}
			onClose={onClose}
			height="60%"
			open={open}
			key="set-recipient"
		>
			<div className="flex flex-col gap-3">
				{
					!tokenList
						? <></>
						: tokenList.map(item => (
							<div
								key={item.symbol}
								className={twMerge(
									"border-solid border-[1px] rounded-lg border-[#ccc] flex items-center gap-2 p-3",
								)}
								onClick={() => item.status.value !== "pending" && onSelect(item)}
							>
								<div className="flex items-center justify-between gap-2 w-full" >
									<div className="flex-shrink-0">
										<Image preview={false} src={item.logo} className='!w-8 !h-8 rounded-full' />
									</div>

									<div className="flex flex-col gap-1">
										<p className="font-bold text-base">{item.symbol} </p>
										<p className="font-medium text-secondary">{item.name} {item.status.value === "pending" ? `(${t("comingSoon")})` : ""}</p>
									</div>

									<p className="text-right flex-1">{item.rate}$</p>
								</div>
							</div>
						))
				}
			</div>
		</Drawer>
	)
}

export default SelectToken